import React, { Fragment, useRef, useState, useMemo } from 'react';
import { exposeTestId } from '../../config';
import { connect } from 'react-redux';
import { Button, ButtonVariant } from '@sas/nova-commons/components/Button';
import { createUseHtmlId } from '@sas/nova-commons/hooks/useHtmlId';
import { InformationButtonSmall } from '@sas/react-svg';
import { Popover } from '@sas/nova-commons/components/Popover';
import { selectLayoutState, selectTitleState } from '../../store/selectors';
import { bindActionCreators } from 'redux';
import { TitleState } from '../../store/title/TitleState';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { useI18n } from '../../locale/I18nContext';
import processTitleHtml from './processTitleHtml';
import cn from './Title.css.json';
import './Title.css';
export const TitleBase = ({ id, title, actions, additionalInformation, customPadding, }) => {
    const dt = useDesignTokens();
    const titleId = useInfoButtonTitleId();
    const titleHtml = useMemo(() => (!title ? undefined : processTitleHtml({ __html: title })), [
        title,
    ]);
    return !titleHtml ? null : (React.createElement("div", { style: renderInlineCssVars({
            fg: dt.reportTokens.text.basic.fg,
            'font-size': dt.reportTokens.font.size.xxl,
            'custom-padding': typeof customPadding === 'number' ? customPadding + 'px' : customPadding,
        }, 'title'), className: additionalInformation ? cn.titleContainerFlex : cn.titleContainer, onDoubleClick: () => {
            actions.notifyDoubleClick(id);
        } },
        React.createElement("div", { className: cn.title, "data-testid": exposeTestId() ? id + '-title' : null, dangerouslySetInnerHTML: titleHtml }),
        additionalInformation && (React.createElement(InfoButton, { titleId: titleId, popupContent: React.createElement(AdditionalInfoContent, { titleId: titleId, title: additionalInformation.title, text: additionalInformation.text }) }))));
};
export const Title = connect((state, props) => {
    var _a, _b;
    const { title, additionalInformation } = (_a = selectTitleState(state, props.id)) !== null && _a !== void 0 ? _a : {};
    const { titlePadding } = (_b = selectLayoutState(state, props.id)) !== null && _b !== void 0 ? _b : {};
    return { title, additionalInformation, customPadding: titlePadding };
}, (dispatch) => ({
    actions: bindActionCreators(TitleState.actions, dispatch),
}))(TitleBase);
const useInfoButtonTitleId = createUseHtmlId('vaReactCore_InfoButtonTitle');
const infoButtonTooltipKey = { key: 'TitleInfoButton.tooltip.txt' };
const InfoButton = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const popoverTargetRef = useRef(null);
    const tooltip = useI18n(infoButtonTooltipKey);
    return (React.createElement(Fragment, null,
        React.createElement(Button, { ref: popoverTargetRef, variant: ButtonVariant.Icon, icon: { icon: InformationButtonSmall }, tooltip: tooltip, ariaLabel: tooltip, "aria-haspopup": true, onPress: () => {
                setIsOpen(true);
            } }),
        React.createElement(Popover, { role: "dialog", focusable: true, referenceElementRef: popoverTargetRef, placement: "auto", ariaLabelledby: props.titleId, isOpen: isOpen, onClose: () => {
                setIsOpen(false);
            } }, props.popupContent)));
};
/**
 * Primary-based text color, used for dialog headers
 */
function getColorTextPrimary(dt) {
    switch (dt.themeVariant) {
        case 'dark':
            return dt.reportTokens.c.p2;
        case 'high-contrast':
            return dt.reportTokens.c.p3;
        default:
            return dt.reportTokens.c.p;
    }
}
const AdditionalInfoContent = (props) => {
    const dt = useDesignTokens();
    const tokens = {
        fg: dt.reportTokens.text.basic.fg,
        'title-fg': getColorTextPrimary(dt),
        'font-weight-default': dt.reportTokens.font.weight.default,
        'font-weight-thick': dt.reportTokens.font.weight.thick,
        'font-size-m': dt.reportTokens.font.size.m,
        pd: dt.tokens['space-base-m'],
        'tiny-pd': dt.tokens['space-base-xs'],
        'small-pd': dt.tokens['space-base-s'],
    };
    return (React.createElement("div", { className: cn.helpContent, style: renderInlineCssVars(tokens, 'info-popup-content') },
        React.createElement("span", { id: props.titleId, className: cn.helpContentHeader }, props.title),
        React.createElement("p", { className: cn.helpContentText }, props.text)));
};
